/**
 * Scroll the gallery up to the folder bar (which sits just below the fixed
 * navbar) rather than the very top of the page. This keeps a folder switch or
 * an AI-search result from flying the guest all the way back up to the cover
 * photo. Relies on an anchor with id "gallery-content-top" rendered right
 * before the folder bar, whose scroll-margin-top offsets the navbar height.
 */
export const scrollToGalleryTop = () => {
  const anchor = document.getElementById("gallery-content-top")
  if (anchor) {
    anchor.scrollIntoView({ block: "start" })
    return
  }

  // Fallback to the old behavior if the anchor isn't in the DOM.
  const scroller = document.querySelector(".max-h-screen.overflow-y-scroll")
  if (scroller) (scroller as HTMLElement).scrollTop = 0
}
